import Scoregraph from './Scoregraph';

export default Scoregraph;
